// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table th {
    background-color: #0b2d71;
    color: white;
    font-weight: bold;
}

.details-table th {
    background-color: #007bff;
    color: #fff;
    padding: 10px;
    text-align: left;
}

.button-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    gap: 40px;
}

.form-group {
    margin-bottom: 1rem;
    text-align: left;
}

th,
td {
    border: 1px solid white;
    text-align: center;
    padding: 8px;
}

.title {
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: center;
    font-size: 100%;
}

.title h3 {
    color: white !important;
    text-align: left;
    margin-top: auto;
    margin-bottom: auto;
}

.shift-left {
    margin-left: -7%;
}

.star {
    color: red;
}

.message{
    font-size: 115%;
     color: red;
     font-weight: bolder;
     justify-content: center;
     align-items: center;
}

`, "",{"version":3,"sources":["webpack://./src/app/modules/temporaryredelegation/redelegation/redelegation.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;KACd,UAAU;KACV,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;AACxB","sourcesContent":["table th {\n    background-color: #0b2d71;\n    color: white;\n    font-weight: bold;\n}\n\n.details-table th {\n    background-color: #007bff;\n    color: #fff;\n    padding: 10px;\n    text-align: left;\n}\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    gap: 40px;\n}\n\n.form-group {\n    margin-bottom: 1rem;\n    text-align: left;\n}\n\nth,\ntd {\n    border: 1px solid white;\n    text-align: center;\n    padding: 8px;\n}\n\n.title {\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: center;\n    font-size: 100%;\n}\n\n.title h3 {\n    color: white !important;\n    text-align: left;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.shift-left {\n    margin-left: -7%;\n}\n\n.star {\n    color: red;\n}\n\n.message{\n    font-size: 115%;\n     color: red;\n     font-weight: bolder;\n     justify-content: center;\n     align-items: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
